import { useRecoilValue } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import N_MatchMakingPartyTab, {
  N_matchMakingPartyTabState,
} from "../../components/pages/Party/N_MatchMakingPartyInfo/N_MatchMakingPartyTab";
import N_MatchMakingParty from "../../components/pages/Party/N_MatchMakingPartyInfo/PartyInfo";
import N_MatchMakingEmail from "../../components/pages/Party/N_MatchMakingPartyInfo/EmailInfo";
import N_MatchMakingSubs from "../../components/pages/Party/N_MatchMakingPartyInfo/SubsInfo";

export default function MatchMakingPartyInfo() {
  const tab = useRecoilValue(N_matchMakingPartyTabState);

  return (
    <>
      <PageTitle title="뉴_매치메이킹 파티" />

      <N_MatchMakingPartyTab />

      {tab === 0 ? (
        <N_MatchMakingParty />
      ) : tab === 1 ? (
        <N_MatchMakingEmail />
      ) : (
        <N_MatchMakingSubs />
      )}
    </>
  );
}
